/**
 * Bloquea la acción por defecto del navegador (p. ej. copy/paste en emails de gift card).
 */
export function blockDefaultEvent(event: { preventDefault: () => void }): void {
    event.preventDefault()
}
